var CatalogPage = {
  pagination: null,
  list: []
};

CatalogPage.init = function () {
  CatalogPage.buildProductsList();
  CatalogPage.buildPagination();
  FilterWidget.init();
  VersionModal.onSubscribeForVersion = CatalogPage.onSubscribeForVersion;
  CatalogPage.markFavs();
  if ($('.catalog_page').length) {
    window.onpopstate = function (e) {
      if (e.state) {
        CatalogPage.buildProductsList(e.state.products);
        CatalogPage.buildPagination(e.state.pagination);
        if (e.state.filters) {
          FilterWidget.clearAllFilters({triggerChange: true});
          for (var p in e.state.filters) {
            var filters = e.state.filters[p];
            filters && filters.forEach(function (f) {
              FilterWidget.onFilterAdd(f)
            });
          }
          FilterWidget.setPriceSlider(e.state.filters.priceFrom, e.state.filters.priceTo);
        }
      } else {
        window.location.reload()
      }
    };
  }
};

CatalogPage.changeHeader = function (menu) {
  if (menu && menu.catalogBanner) {
    $('.catalog_description2').html(menu.catalogBanner);
  }

  //var filter = false;
  if (menu && menu.attrTitle) {
    $('.catalog_description').html('<h1>' + menu.attrTitle + '</h1>');
  } else if (menu && (menu.title || menu.text)) {
    $('.catalog_description').html('<h1>' + (menu.title || menu.text) + '</h1>');
  } else if (FilterWidget && $.isPlainObject(FilterWidget.selected) && !$.isEmptyObject(FilterWidget.selected)) {
    $('.catalog_description').html('<h1>' + FilterWidget.selected[Object.getOwnPropertyNames(FilterWidget.selected)[0]][0].label + '</h1>');
    //  $('.catalog_description .catalog_description_filter').remove();
    
    //var text = FilterWidget.selected[Object.getOwnPropertyNames(FilterWidget.selected)[0]][0].name;
    //var capitalizedText = text.charAt(0).toUpperCase() + text.slice(1);
    
    //$('.catalog_description h1').after('<p class="catalog_description_filter">' + 
//	capitalizedText +' : '+FilterWidget.selected[Object.getOwnPropertyNames(FilterWidget.selected)[0]][0].label
//	 + '</p>');
  //  filter = true;
  } else {
    $('.catalog_description').html('<h1>Wszystkie produkty</h1>');
  }
  //if(filter==false){
   //   $('.catalog_description .catalog_description_filter').remove();
  //}

};

CatalogPage.historyPushState = function (url, data) {
  data.filters = FilterWidget.getSelectedFilters();
  window.history.pushState(data, "", url);
};

CatalogPage.onFiltersChange = function (filters) {
  return jQuery.ajax({
    url: "/catalog/search",
    method: "post",
    data: JSON.stringify({
      context: "filterChange",
      filters: filters,
      path: location.pathname
    }),
    contentType: 'application/json; charset=utf-8',
    success: function (resp) {
      CatalogPage.buildProductsList(resp.products);
      CatalogPage.buildPagination(resp.pagination);
      CatalogPage.historyPushState(resp.url, resp);
      CatalogPage.markFavs();
      FilterWidget.filterCollections();
      CatalogPage.changeHeader(resp.menu);
      fP();
    }
  });
};

CatalogPage.pageChanged = function (pageQuery) {
  var url = location.pathname + pageQuery;
  return jQuery.post("/catalog/search", {
    context: "pageChange",
    path: location.pathname,
    query: pageQuery.replace("?", "")
  }, function (resp) {
    CatalogPage.buildProductsList(resp.products);
    CatalogPage.buildPagination(resp.pagination);
    CatalogPage.historyPushState(url, resp);
    CatalogPage.markFavs();
  })
};

CatalogPage.buildPagination = function (html) {
  if (!CatalogPage.pagination) {
    CatalogPage.pagination = {
      top: new Pagination($("#pagination_top")),
      bottom: new Pagination($("#pagination_bottom"))
    };
    CatalogPage.pagination.top.bindEvents();
    CatalogPage.pagination.bottom.bindEvents();
  }
  if (html) {
    CatalogPage.pagination.top.update(html);
    CatalogPage.pagination.bottom.update(html);
  }
};

CatalogPage.buildProductsList = function (productHtml) {
  CatalogPage.list.length = 0;
  if (typeof productHtml !== "undefined") {
    $('#products').empty().append(productHtml);
  }
  $("#products > .product").each(function (i, element) {
    CatalogPage.list.push(new ProductView(element, CatalogPage));
  });
};

CatalogPage.findProductView = function (productId) {
  for (var i = 0; i < CatalogPage.list.length; i++) {
    if (CatalogPage.list[i].product._id === productId) {
      return CatalogPage.list[i];
    }
  }
};

CatalogPage.addProductToCart = function (product) {
  if (product.versionQty > 1) {
    VersionModal.loadModal(product._id, {
      onAddToCart: function (product) {
        Cart.addItems({
          type: product.type,
          product: product.product,
          version: product.version,
          qty: 1
        });
      }
    });
  } else {
    Cart.addItems({
      type: product.type,
      product: product._id,
      version: product.version,
      qty: 1
    });
  }
};

CatalogPage.addProductToFav = function (product) {
  Fav.favProduct(product._id, function () {
    Fav.loadFavs();
    var productView = CatalogPage.findProductView(product._id);
    productView.setFav(true);
  });
};

CatalogPage.removeProductFromFavs = function (product) {
  Fav.unFavProduct(product._id, function () {
    Fav.loadFavs();
    var productView = CatalogPage.findProductView(product._id);
    productView.setFav(false);
  });
};

CatalogPage.onSubscribeForVersion = function (productId, versionId) {

};

CatalogPage.markFavs = function () {
  Fav.loadFavs(function (resp) {
    CatalogPage.list.forEach(function (productView) {
      if (resp.favorites && resp.favorites.indexOf(productView.product._id) >= 0) {
        productView.setFav(true);
      }
    })
  });
};

$(CatalogPage.init);

/**********/

var FilterWidget = {};

FilterWidget.init = function () {
  FilterWidget.$priceFrom = $("#priceStart");
  FilterWidget.$priceTo = $("#priceFinish");
  FilterWidget.$manufactures = $('#manufacturer');
  if (!FilterWidget.$manufactures.length) {
    return;
  }
  FilterWidget.$manufactures.select2({placeholder: "Wybierz markę", value: ""})
    .on('select2:select', function (e) {
      if (e.params.data) {
        var f = {
          _id: e.params.data.id,
          label: e.params.data.text,
          name: this.name,
          url: e.params.data.element.getAttribute("data-url")
        };
        // if (FilterWidget.selected.manufacturer) {
        //   $('#' + FilterWidget.selected.manufacturer[0]._id).remove();
        //   FilterWidget.selected.manufacturer.length = 0;
        // }
        FilterWidget.onFilterAdd(f);
        CatalogPage.onFiltersChange(FilterWidget.selected);
      }
    });
  FilterWidget.selected = FilterWidget.getSelectedFilters();
  FilterWidget.markFilters(FilterWidget.selected);
  $('.widget-body input[type="checkbox"]').click(FilterWidget.onCheckBoxChange);

  for (var p in FilterWidget.selected) {
    var filters = FilterWidget.selected[p];
    filters.forEach(function (f) {
      $('.filter_' + f._id + ' i').click(FilterWidget.onFilterRemoveClick);
    });
  }

  $('.clear-filters').click(function (evt) {
    evt.preventDefault();
    FilterWidget.clearAllFilters();
  });

  $('.widget .more, .widget .less').click(function (evt) {
    evt.preventDefault();
    FilterWidget.toggleAllOptions(this);
  });

  var slider = FilterWidget.slider = document.getElementById('slider');

  if (slider) {
    var inputs = [FilterWidget.$priceFrom.get(0), FilterWidget.$priceTo.get(0)];
    var min = parseFloat(slider.dataset.min);
    var max = parseFloat(slider.dataset.max);
    if (min === max) {
      min = 0;
    }
    FilterWidget.sliderMinMax = [min, max];
    noUiSlider.create(slider, {
      start: [FilterWidget.$priceFrom.val() || min, FilterWidget.$priceTo.val() || max],
      connect: true,
      step: (max - min) / (max / min),
      range: {
        'min': [min],
        'max': [max]
      },
      format: {
        to: function (value) {
          return parseInt(value);
        },
        from: function (value) {
          return parseInt(value);
        }
      }
    });
    slider.noUiSlider.on('change', function (values, handle) {
      var input = inputs[handle];
      input.value = values[handle];
      input.id === "priceStart" ? FilterWidget.onPriceFromChange.call(input) :
        FilterWidget.onPriceToChange.call(input);
    });
  }

  FilterWidget.$priceFrom.change(function () {
    if (slider) {
      slider.noUiSlider.set([this.value]);
    }
    FilterWidget.onPriceFromChange.call(this);
  });
  FilterWidget.$priceTo.change(function () {
    if (slider) {
      slider.noUiSlider.set([null, this.value]);
    }
    FilterWidget.onPriceToChange.call(this);
  });

  FilterWidget.filterCollections(FilterWidget.selected);
};

FilterWidget.onPriceFromChange = function () {
  var f = {
    _id: "priceFrom",
    label: "Od " + this.value + " PLN",
    name: "priceFrom",
    url: this.value
  };
  FilterWidget.removeFilterElement(f._id);
  //$('#' + f._id).remove();
  FilterWidget.onFilterAdd(f);
  CatalogPage.onFiltersChange(FilterWidget.selected);
};

FilterWidget.onPriceToChange = function () {
  var f = {
    _id: "priceTo",
    label: "Do " + this.value + " PLN",
    name: "priceTo",
    url: this.value
  };
  FilterWidget.removeFilterElement(f._id);
  //$('#' + f._id).remove();
  FilterWidget.onFilterAdd(f);
  CatalogPage.onFiltersChange(FilterWidget.selected);
};

FilterWidget.clearAllFilters = function (options) {
  options = options || {};
  FilterWidget.selected = {};
  FilterWidget.$manufactures.val(null).trigger("change");
  $('.sorting__choosed .list').empty();
  $('.filters input[type="checkbox"]').prop("checked", false);
  FilterWidget.$priceFrom.val("");
  FilterWidget.$priceTo.val("");
  if (options.triggerChange === true) {
    return;
  }
  CatalogPage.onFiltersChange(FilterWidget.selected);
};

FilterWidget.onCheckBoxChange = function () {
  var label = $('label[for="' + this.id + '"]').html();
  //FilterWidget.selected[this.name] = FilterWidget.selected[this.name] || [];
  var f = {_id: this.value, label: label, name: this.name, url: this.getAttribute("data-url")};
  if (this.checked) {
    FilterWidget.onFilterAdd(f);
  } else {
    FilterWidget.onFilterRemove(f)
  }
  CatalogPage.onFiltersChange(FilterWidget.selected);
};

FilterWidget.onFilterRemove = function (f) {
  if (!FilterWidget.selected[f.name]) {
    return;
  }
  for (var fi = 0; fi < FilterWidget.selected[f.name].length; fi++) {
    if (FilterWidget.selected[f.name][fi]._id === f._id) {
      FilterWidget.selected[f.name].splice(fi, 1);
      break;
    }
  }
  if (FilterWidget.selected[f.name].length === 0) {
    delete FilterWidget.selected[f.name];
  }
  FilterWidget.removeFilterElement(f._id);
  //$('#' + f._id).remove();
  if (f.name === "priceFrom") {
    FilterWidget.$priceFrom.val('');
  }
  if (f.name === "priceTo") {
    FilterWidget.$priceTo.val('');
  }
};

FilterWidget.onFilterAdd = function (f) {
  var singleFilters = ["priceFrom", "priceTo", "wyprzedaz", 'nowosc', "bestseller", "manufacturer"];
  if (singleFilters.indexOf(f.name) >= 0) {
    if (FilterWidget.selected[f.name] && FilterWidget.selected[f.name][0]) {
      FilterWidget.removeFilterElement(FilterWidget.selected[f.name][0]._id);
      //$('#' + FilterWidget.selected[f.name][0]._id).remove();
    }
    FilterWidget.selected[f.name] = [f];
  } else {
    FilterWidget.selected[f.name] = FilterWidget.selected[f.name] || [];
    var existing = FilterWidget.selected[f.name].filter(function (_f) {
      return _f._id === f._id;
    });
    if (!existing || existing.length === 0) {
      FilterWidget.selected[f.name].push(f);
    }
  }
  $('.sorting__choosed .list').append(' <a href="#" class="filter_' + f._id + '" data-prop="' + f.name + '" id="' + f._id + '" data-url="' + f.url + '"><span>' + f.label + '</span><i class="icon-close"></i></a>');
  $('.filter_' + f._id + ' .icon-close').click(FilterWidget.onFilterRemoveClick);
  $('.clear-filters').show();
};

FilterWidget.removeFilterElement = function (filterID) {
  $('.filter_' + filterID).remove();
};

FilterWidget.onFilterRemoveClick = function (evt) {
  evt.preventDefault();
  var link = $(this).parent();
  var f = {_id: link.attr("id"), label: link.html(), name: link.attr("data-prop"), url: link.attr("data-url")};
  $('input[value="' + f._id + '"]').prop("checked", false);
  if (f.name === 'manufacturer') {
    FilterWidget.$manufactures.val(null).trigger("change");
  }
  FilterWidget.onFilterRemove(f);
  CatalogPage.onFiltersChange(FilterWidget.selected);
};

FilterWidget.getSelectedFilters = function () {
  var selectedFilters = {};
  $('.sorting__choosed').find(".list > a").each(function (i, link) {
    var prop = link.getAttribute("data-prop");
    var filter = {
      _id: link.id,
      label: link.childNodes[0].innerHTML,
      name: link.getAttribute("data-prop"),
      url: link.getAttribute("data-url")
    };
    selectedFilters[prop] = selectedFilters[prop] || [];
    var existing = selectedFilters[prop].filter(function (_f) {
      return _f._id === filter._id;
    });
    if (!existing || existing.length === 0) {
      selectedFilters[prop].push(filter);
    }
  });
  return selectedFilters;
};

FilterWidget.markFilters = function (selectedFilters) {
  for (var p in selectedFilters) {
    var set = selectedFilters[p];
    if (p === "priceFrom") {
      FilterWidget.$priceFrom.val(set[0].url);
      continue;
    }
    if (p === "priceTo") {
      FilterWidget.$priceTo.val(set[0].url);
      continue;
    }
    set.forEach(function (filter) {
      var input = document.querySelector('input[value="' + filter._id + '"]');
      if (input) {
        input.checked = true;
      }
    });
  }
  if (selectedFilters.manufacturer) {
    selectedFilters.manufacturer.forEach(function (f) {
      FilterWidget.$manufactures.val(f._id);
      FilterWidget.$manufactures.trigger('change');
    }, this);
  }
};

FilterWidget.toggleAllOptions = function (button) {
  $(button).toggleClass('hidden');
  $(button).siblings('a').toggleClass('hidden');
  if ($(button).hasClass('more')) {
    return $(button).siblings('label').removeClass('hidden');
  }
  $(button).siblings('label').each(function (index, label) {
    if (index > 4) {
      $(label).addClass('hidden');
    }
  });
};

FilterWidget.setPriceSlider = function (from, to) {
  if (from || to) {
    var minmax = FilterWidget.sliderMinMax;
    FilterWidget.slider.noUiSlider.set([
      from && from[0] ? parseInt(from[0].url) : minmax[0],
      to && to[0] ? parseInt(to[0].url) : minmax[1]
    ]);
  }
};

//todo: remove this function in next version of the filter
//the main purpose is to filter the collectionNames accroding to manufacturer
FilterWidget.filterCollections = function () {
  var selectedFilters = FilterWidget.selected;
  if (selectedFilters.manufacturer) {
    return jQuery.post("/catalog/filter/collections", {
      manufacturer: selectedFilters.manufacturer[0]._id
    }, function (collections) {
      if (collections.length === 0) {
        $('#collectionName').hide();
      } else {
        $('#collectionName').show();
      }
      $('#collectionName .widget-body label').hide();
      $('#collectionName .widget-body label.hidden').removeClass('hidden').addClass('_hidden');
      $('#collectionName .widget-body a').hide();
      collections.forEach(function (col) {
        var input = $('input[value="' + col._id + '"]');
        if (input.length) {
          input.next().css({'display': "block"});
        }
      });
    });
  } else {
    //show all
    $('#collectionName').show();
    $('#collectionName .widget-body label').css('display', 'block');
    $('#collectionName .widget-body label._hidden').removeClass('_hidden').addClass('hidden');
    $('#collectionName .widget-body a').show();
  }
};

function fP(){
// Znajdź pierwszy paragraf
    var firstParagraph = $('.catalog_description2 p').first();

    // Ukryj wszystkie elementy po pierwszym paragrafie
    firstParagraph.nextAll().wrapAll('<div id="hiddenContent" style="display: none;"></div>');

    // Dodaj link Read More na końcu pierwszego paragrafu
    firstParagraph.append(' <a href="#" id="readMore">Czytaj więcej</a>');

    // Dodaj obsługę kliknięcia linku
    $('#readMore').click(function(e) {
        e.preventDefault(); // Zapobiegaj domyślnej akcji linku
        // Pokaż ukrytą zawartość
        $('#hiddenContent').show();
        // Usuń link Read More
        $(this).remove();
    });
}

$(document).ready(function(){
	fP();
});
